import produce from "immer";
import DragLayerComponent from "./drag";
import DesignComponent from "./design";
import RuntimeComponent from "./runtime";
import {
  ComponentType,
  ImageStyleProps,
  DefaultImageComponentProperty,
} from "common/components/types";

const Image: ComponentType = {
  DragLayerComponent: DragLayerComponent,
  DesignComponent: DesignComponent,
  RuntimeComponent: RuntimeComponent,
  property: produce(DefaultImageComponentProperty, (draft) => {
    draft.name = "MSG_CREATOR_COMPONENT_NAME_IMAGE";
    draft.defaultName = "MSG_CREATOR_COMPONENT_NAME_IMAGE";

    const initalWidth = 100;
    const initalHeight = 100;

    draft.style.defaultLayout.width = initalWidth;
    draft.style.defaultLayout.height = initalHeight;
    draft.style.defaultImage = ImageStyleProps;
    draft.style.defaultView.borderWidth = 4;
    draft.style.defaultView.borderColor = "#4C9DF1";
    draft.style.defaultView.borderRadius = 0;

    draft.style.layout.width = initalWidth;
    draft.style.layout.height = initalHeight;
    draft.style.image = ImageStyleProps;
    draft.style.view.borderWidth = 4;
    draft.style.view.borderColor = "#4C9DF1";
    draft.style.view.borderRadius = 0;

    draft.events = ["image_click_event"];
  }),
};

export default Image;
